import { useTheme } from "@emotion/react";
import {
  ArrowBackIosNewOutlined,
  ArrowForwardIosOutlined,
  Check,
  ClearOutlined,
  CreateOutlined,
  DoneOutlined,
  ErrorOutlineOutlined,
  LocalOfferOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  CircularProgress,
  Divider,
  Drawer, // <- Adicionado o import do Drawer
  IconButton,
  Paper,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import api from "../../../services/api";
import { StatusChipModal } from "../../../utils/chipsErp/chipStatusModal";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import MentionTextField from "../../textfieldMention";
import VirtualizedAutocomplete from "../../virtualization/virtualizedAutocomplete";
import AnexosTicketComponent from "../anexosTicketComponent";
import AnswerQuestionsComponent from "../answerQuestionsComponent";
import DescricaoTicketComponent from "../descricaoTicketComponent";
import EditTicketComponent from "../editTicketComponent";
import MensagensTicketComponent from "../mensagensTicketComponent";
import OrdemServiceComponent from "../ordemServiceComponent";
import ReportsComponent from "../reportsComponent";
import RfoComponent from "../rfoComponent";
import TimelineComponent from "../timelineComponent";
import useStyles from "./styles";
import CopyButton from "../shared/copyButton";
import { gutterX } from "../shared/ticketLayout";
import buscarClienteIdLocal from "../shared/clienteIdLocal";

/**
 * Componente principal para renderizar o conteúdo do modal de atendimento.
 */

function htmlForText(html) {
  if (!html) return "";

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  function extrairTexto(node) {
    let texto = "";

    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        texto += child.textContent;
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tag = child.tagName;

        switch (tag) {
          case "BR":
            texto += "\n";
            break;
          case "P":
          case "DIV":
            texto += extrairTexto(child) + "\n";
            break;
          case "LI":
            texto += "- " + extrairTexto(child) + "\n";
            break;
          case "UL":
          case "OL":
            texto += extrairTexto(child) + "\n";
            break;
          default:
            texto += extrairTexto(child);
        }
      }
    });

    return texto;
  }

  const resultado = extrairTexto(tempDiv);
  return resultado.replace(/\n{3,}/g, "\n\n").trim();
}

export default function TicketModalContent(params) {
  const {
    open, // <- Adicionado para controlar o Drawer
    loading, // <- Adicionado para controlar o spinner principal
    handleClose,
    erp,
    // Id do ERP escolhido na tela; vai no body das rotas (sem ele, o backend
    // usa a variável ERP).
    erpId,
    ticketDetails,
    convertStatusVoalle,
    status,
    labelTabsErp,
    value,
    handleChange,
    isEdit,
    setTicketDetails,
    itensPublic,
    setItensPublic,
    setSnackbar,
    // Esconde as ações do cabeçalho (editar/finalizar).
    somenteLeitura = false,
    isCliente = false,
    canSendMessage = false,
    canSendAnexo = false,
    fluxoAtendimentoColor = null,
    setEditedTicket = () => {},
    historicoFluxoAtendimento = [],
    setIsEditTicket = () => {},
    isEditTicket = false,
    setIsFinishTicket = () => {},
    isFinishTicket = false,
    setIsEditOs = () => {},
    isEditOs = false,
    setIsNewOs = () => {},
    isNewOs = false,
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);

  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [confirmacaoSaidaPaginaFinish, setConfirmacaoSaidaPaginaFinish] =
    useState(false);
  // Clique fora do drawer (ou Esc) durante uma edição: confirmar fecha o drawer.
  const [confirmacaoFecharDrawer, setConfirmacaoFecharDrawer] = useState(false);
  const [dataTicket, setDataTicket] = useState({});
  const [motivoFechamento, setMotivoFechamento] = useState([]);
  const [tipoAtendimento, setTipoAtendimento] = useState([]);
  const [error, setError] = useState(false);
  const [loadingServicos, setLoadingServicos] = useState(false);
  const [loadingCreateTicket, setLoadingCreateTicket] = useState(false);
  const [servicos, setServicos] = useState([]);
  const [loadingParams, setLoadingParams] = useState(false);
  const [origemContato, setOrigemContato] = useState([]);
  const [userResponsaveis, setUserResponsaveis] = useState([]);
  const [etapasFluxoAtendimento, setEtapasFluxoAtendimento] = useState([]);
  const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);
  const [statusAtendimento, setStatusAtendimento] = useState([]);
  const [requiredRfo, setRequiredRfo] = useState(false);

  const statusFechamento = [
    { value: "concluido", label: "Concluído" },
    { value: "sem_conclusao", label: "Sem conclusão" },
  ];

  // Renomeado para não conflitar com a prop 'loading' principal
  const [loadingFinishParams, setLoadingFinishParams] = useState(false);
  const [loadingFinishTicket, setLoadingFinishTicket] = useState(false);
  const [paramsFinishTicket, setParamsFinishTicket] = useState({
    statusFechamento: { value: "", label: "" },
    motivoFechamento: { id: "", descricao: "" },
    descricaoFechamento: "",
    tipoAtendimento: { id: "", descricao: "" },
  });

  const getServicos = async () => {
    try {
      setLoadingServicos(true);
      const response = await api.post("/interno/find/allServiceClient", {
        cnpj: ticketDetails?.cliente?.cnpj,
        clienteId: await buscarClienteIdLocal(
          ticketDetails?.cliente?.codigo_cliente,
          erpId,
        ),
      });
      setServicos(response?.data);
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };

  const getParamsEditTicket = async () => {
    setLoadingParams(true);
    try {
      const response = await api.post("/interno/find/paramsNewTicket", {
        erpId,
      });

      setUserResponsaveis(response?.data?.userResponsaveis || []);
      setMotivoFechamento(response?.data?.motivoFechamento || []);
      setTipoAtendimento(response?.data?.tipoAtendimento || []);
      setOrigemContato(response?.data?.origemContato || []);
      const statusAtendimento =
        response?.data?.statusAtendimento?.filter((item) => item?.id !== 3) ||
        [];
      setStatusAtendimento(statusAtendimento);
      setEtapasFluxoAtendimento(response?.data?.etapasFluxoAtendimento || []);
      setUsuariosSelecionados(ticketDetails?.usuarios_responsaveis || []);

      setDataTicket({
        idAtendimento: ticketDetails?.id_atendimento,
        tipoAtendimentoId: response?.data?.tipoAtendimento?.find(
          (item) =>
            item?.descricao?.trim() === ticketDetails?.tipo_atendimento?.trim(),
        )?.id,
        statusAtendimentoId: ticketDetails?.status?.id,
        origemContatoId: response?.data?.origemContato?.find(
          (item) =>
            item?.origemContato?.trim() ===
            ticketDetails?.origem_contato?.descricao?.trim(),
        )?.idOrigemContato,
        descricaoAbertura: ticketDetails?.descricao_abertura || "",
        usuariosResponsaveis: ticketDetails?.usuarios_responsaveis || [],
        idEtapaFluxoAtendimento:
          ticketDetails?.fluxo_atendimento?.idEtapaFluxoAtendimento || null,
        clienteServicoId: ticketDetails?.cliente_servico?.id_cliente_servico,
        clienteErpId: ticketDetails?.cliente?.codigo_cliente,
        cnpj: ticketDetails?.cliente?.cnpj || null,
        nome: nomeCliente || null,
        telefone: ticketDetails?.cliente?.telefone_primario,
        email: ticketDetails?.cliente?.email_principal,
        enderecoInstalacao: ticketDetails?.cliente?.endereco_instalacao,
      });
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };

  const getparamsFinishTicket = async () => {
    setLoadingFinishParams(true);
    setIsFinishTicket(true);
    try {
      const response = await api.post("/interno/find/paramsFinishTicket", {
        erpId,
      });

      setMotivoFechamento(response?.data?.motivoFechamento);
      setTipoAtendimento(response?.data?.tipoAtendimento);
      const tipoAtendimento =
        response?.data?.tipoAtendimento.find(
          (item) =>
            item?.descricao?.trim() === ticketDetails?.tipo_atendimento?.trim(),
        ) || "";

      setParamsFinishTicket((prev) => ({
        ...prev,
        tipoAtendimento: {
          id: tipoAtendimento?.id,
          descricao: tipoAtendimento?.descricao?.trim(),
        },
      }));
    } catch (error) {
      console.error("Erro ao obter o corpo do fechamento do ticket:", error);
      setSnackbar({
        children: "Erro ao processar o fechamento do atendimento.",
        severity: "error",
      });
      setIsFinishTicket(false);
    } finally {
      setLoadingFinishParams(false);
    }
  };

  // Centraliza as lógicas de interceptação de fechamento
  const handleCloseAttempt = () => {
    if (isEditTicket || isFinishTicket || isEditOs || isNewOs) {
      setConfirmacaoFecharDrawer(true);
    } else {
      handleClose();
    }
  };

  // Sai de qualquer modo de edição e fecha o drawer. Diferente do "Cancelar"
  // dos formulários, que só volta para os detalhes do atendimento.
  const handleConfirmarFecharDrawer = () => {
    setConfirmacaoFecharDrawer(false);
    setIsEditTicket(false);
    setDataTicket({});
    setIsFinishTicket(false);
    setError(false);
    setIsEditOs(false);
    setIsNewOs(false);
    handleClose();
  };

  const handleCloseEditTicket = () => {
    setIsEditTicket(false);
    setConfirmacaoSaidaPagina(false);
    setDataTicket({});
  };

  const handleCloseFinishTicket = () => {
    setConfirmacaoSaidaPaginaFinish(false);
    setIsFinishTicket(false);
    setError(false);
  };

  const handleEditTicket = () => {
    setIsEditTicket(true);
    getServicos();
    getParamsEditTicket();
  };

  const finishTicket = async () => {
    const idTipoAtendimento =
      paramsFinishTicket?.tipoAtendimento?.descricao?.trim() !==
      ticketDetails?.tipo_atendimento?.trim()
        ? paramsFinishTicket?.tipoAtendimento?.id
        : null;

    if (
      !paramsFinishTicket?.motivoFechamento?.id ||
      !paramsFinishTicket?.tipoAtendimento?.id ||
      !paramsFinishTicket?.statusFechamento?.value ||
      !paramsFinishTicket?.descricaoFechamento?.trim() ||
      ((paramsFinishTicket?.causaRfo?.trim() ||
        paramsFinishTicket?.solucaoRfo?.trim()) &&
        (!paramsFinishTicket?.causaRfo?.trim() ||
          !paramsFinishTicket?.solucaoRfo?.trim()))
    ) {
      setError(true);
      return;
    }

    const verificationRequiredRfo = motivoFechamento?.find(
      (item) =>
        item?.id?.toString() ===
        paramsFinishTicket?.motivoFechamento?.id?.toString(),
    );

    if (
      verificationRequiredRfo?.requiredRfo &&
      (!paramsFinishTicket?.causaRfo?.trim() ||
        !paramsFinishTicket?.solucaoRfo?.trim())
    ) {
      setError(true);
      setRequiredRfo(true);
      return;
    }

    setError(false);
    setRequiredRfo(false);

    setLoadingFinishTicket(true);
    try {
      const response = await api.post("/interno/finish/ticket", {
        erpId,
        idAtendimento: ticketDetails?.id_atendimento,
        dados: {
          parametros_fechamento: {
            id_motivo_fechamento_atendimento:
              paramsFinishTicket?.motivoFechamento?.id,
            descricao_fechamento:
              paramsFinishTicket?.descricaoFechamento?.trim(),
            status_fechamento: paramsFinishTicket?.statusFechamento?.value,
          },
          fechar_atendimento: true,
        },
        idTipoAtendimento: idTipoAtendimento,
        rfo: {
          causa: paramsFinishTicket?.causaRfo?.trim(),
          solucao: paramsFinishTicket?.solucaoRfo?.trim(),
        },
      });

      setTicketDetails((prev) => ({
        ...prev,
        descricao_fechamento: response?.data?.descricao_fechamento,
        status: {
          descricao: response?.data?.status,
        },
        tipo_atendimento: response?.data?.tipo_atendimento,
        rfo: response?.data?.rfo,
      }));
      setEditedTicket(true);
      setIsFinishTicket(false);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Ocorreu um erro ao finalizar o atendimento",
        severity: "error",
      });
    } finally {
      setLoadingFinishTicket(false);
    }
  };

  const editTicket = async () => {
    setLoadingParams(true);
    try {
      const response = await api.post("/interno/edit/ticket", {
        erpId,
        idAtendimento: ticketDetails?.id_atendimento,
        dataTicket: dataTicket,
      });
      setTicketDetails(response?.data);
      setIsEditTicket(false);
      setEditedTicket(true);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: error?.response?.data?.message,
        severity: "error",
      });
    } finally {
      setLoadingParams(false);
    }
  };

  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };
  const handleCancelNavigationFinish = () => {
    setConfirmacaoSaidaPaginaFinish(false);
  };

  // O título era montado duas vezes com o mesmo condicional de ERP — uma para
  // o tooltip e outra para o texto visível. Um só ponto evita que os dois
  // saiam de sincronia.
  // Nome resolvido no backend conforme a configuração de exibição do cliente.
  const nomeCliente = ticketDetails?.cliente?.nome || "";

  const protocoloAtendimento = ticketDetails?.protocolo || "";

  const tituloAtendimento =
    erp === "VOALLE"
      ? ticketDetails?.geral?.title || ""
      : `Atendimento - ${protocoloAtendimento} - (${
          ticketDetails?.cliente?.codigo_cliente || ""
        }) ${nomeCliente}`;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleCloseAttempt}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      PaperProps={{
        sx: {
          // Ocupa a tela inteira no celular e vai cedendo espaço conforme a
          // largura cresce. O 80% fixo anterior deixava 20% de fundo inútil no
          // celular e ainda espremia todo o conteúdo.
          width: { xs: "100%", sm: "92%", md: "85%", lg: "80%" },
          maxWidth: "100%",
        },
      }}
    >
      {loading ? (
        <Box sx={styles.containerModal}>
          <Box sx={styles.conatinerLoading}>
            <CircularProgress />
          </Box>
        </Box>
      ) : (
        <Box sx={{ ...styles.containerModal }}>
          {isFinishTicket ? (
            <>
              {loadingFinishParams ? (
                <Box sx={styles.conatinerLoading}>
                  <CircularProgress />
                </Box>
              ) : (
                <Box sx={styles.boxFinishAtendimento}>
                  <Box sx={styles.boxTitle}>
                    <LocalOfferOutlined />
                    <Typography sx={styles.titleFinishAtendimento}>
                      Finalizar atendimento - {ticketDetails?.protocolo}
                    </Typography>
                  </Box>

                  <Box sx={styles.boxActionsFinishAtendimento}>
                    <Paper variant="outlined" sx={styles.containerPaper}>
                      <Box sx={styles.boxContainerFinish}>
                        <Box sx={styles.boxTitle}>
                          <DoneOutlined sx={styles.icon} />
                          <Typography sx={styles.subTitle}>
                            Dados de encerramento
                          </Typography>
                        </Box>

                        <Box sx={styles.boxMenuFinishAtendimento}>
                          <VirtualizedAutocomplete
                            size="small"
                            options={statusFechamento}
                            value={paramsFinishTicket?.statusFechamento || null}
                            disabled={loadingFinishTicket}
                            isOptionEqualToValue={(option, value) =>
                              option?.value === value?.value
                            }
                            getOptionLabel={(option) => option?.label || ""}
                            onChange={(event, value) => {
                              setParamsFinishTicket((prev) => ({
                                ...prev,
                                statusFechamento: value,
                              }));
                            }}
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Status do fechamento"
                                error={
                                  error &&
                                  !paramsFinishTicket?.statusFechamento?.value
                                }
                                helperText={
                                  error &&
                                  !paramsFinishTicket?.statusFechamento
                                    ?.value &&
                                  "Status de fechamento obrigatório"
                                }
                              />
                            )}
                          />

                          <VirtualizedAutocomplete
                            size="small"
                            disabled={loadingFinishTicket}
                            options={tipoAtendimento}
                            value={paramsFinishTicket?.tipoAtendimento}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            getOptionLabel={(option) =>
                              option ? `${option.descricao || ""} ` : ""
                            }
                            onChange={(event, value) => {
                              setParamsFinishTicket((prev) => ({
                                ...prev,
                                tipoAtendimento: value,
                              }));
                            }}
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                error={
                                  error &&
                                  !paramsFinishTicket?.tipoAtendimento?.id
                                }
                                helperText={
                                  error &&
                                  !paramsFinishTicket?.tipoAtendimento?.id &&
                                  "Tipo de atendimento obrigatório"
                                }
                                size="small"
                                {...params}
                                label="Tipo do atendimento"
                              />
                            )}
                          />

                          <VirtualizedAutocomplete
                            size="small"
                            options={motivoFechamento}
                            disabled={loadingFinishTicket}
                            getOptionLabel={(option) =>
                              option ? `${option.descricao || ""} ` : ""
                            }
                            onChange={(event, value) => {
                              setParamsFinishTicket((prev) => ({
                                ...prev,
                                motivoFechamento: value,
                              }));
                            }}
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                error={
                                  error &&
                                  !paramsFinishTicket?.motivoFechamento?.id
                                }
                                helperText={
                                  error &&
                                  !paramsFinishTicket?.motivoFechamento?.id &&
                                  "Motivo de fechamento obrigatório"
                                }
                                size="small"
                                {...params}
                                label="Motivo do fechamento"
                              />
                            )}
                          />
                        </Box>

                        <MentionTextField
                          disabled={loadingFinishTicket}
                          onChange={(value) =>
                            setParamsFinishTicket((prev) => ({
                              ...prev,
                              descricaoFechamento: value,
                            }))
                          }
                          multiline
                          value={paramsFinishTicket?.descricaoFechamento}
                          label="Descrição de fechamento"
                          variant="outlined"
                          InputProps={{ inputComponent: "textarea" }}
                          error={
                            error &&
                            !paramsFinishTicket?.descricaoFechamento?.trim()
                          }
                          helperText={
                            error &&
                            !paramsFinishTicket?.descricaoFechamento?.trim() &&
                            "Descrição de fechamento obrigatório"
                          }
                          sx={{
                            width: "100%",
                            "& .MuiFilledInput-root": { paddingTop: "20px" },
                            "& textarea": {
                              resize: "vertical",
                              minHeight: "100px",
                              maxHeight: "400px",
                            },
                          }}
                        />
                        <Divider sx={{ margin: "5px 0" }} />
                        <Box sx={styles.boxTitle}>
                          <ErrorOutlineOutlined sx={styles.icon} />
                          <Typography sx={styles.subTitle}>
                            Dados de RFO
                          </Typography>
                        </Box>
                        <MentionTextField
                          disabled={loadingFinishTicket}
                          onChange={(value) =>
                            setParamsFinishTicket((prev) => ({
                              ...prev,
                              causaRfo: value,
                            }))
                          }
                          multiline
                          value={paramsFinishTicket?.causaRfo}
                          label="Causa do problema (RFO)"
                          placeholder="Descreva o problema"
                          variant="outlined"
                          InputProps={{ inputComponent: "textarea" }}
                          error={
                            error &&
                            ((!paramsFinishTicket?.causaRfo?.trim() &&
                              paramsFinishTicket?.solucaoRfo?.trim()) ||
                              requiredRfo)
                          }
                          helperText={
                            error &&
                            ((!paramsFinishTicket?.causaRfo?.trim() &&
                              paramsFinishTicket?.solucaoRfo?.trim()) ||
                              requiredRfo) &&
                            "Causa do problema obrigatório"
                          }
                          sx={{
                            width: "100%",
                            "& .MuiFilledInput-root": { paddingTop: "20px" },
                            "& textarea": {
                              resize: "vertical",
                              minHeight: "100px",
                              maxHeight: "400px",
                            },
                          }}
                        />
                        <MentionTextField
                          disabled={loadingFinishTicket}
                          onChange={(value) =>
                            setParamsFinishTicket((prev) => ({
                              ...prev,
                              solucaoRfo: value,
                            }))
                          }
                          multiline
                          value={paramsFinishTicket?.solucaoRfo}
                          label="Solução do problema (RFO)"
                          variant="outlined"
                          placeholder="Descreva a solução"
                          InputProps={{ inputComponent: "textarea" }}
                          error={
                            error &&
                            ((!paramsFinishTicket?.solucaoRfo?.trim() &&
                              paramsFinishTicket?.causaRfo?.trim()) ||
                              requiredRfo)
                          }
                          helperText={
                            error &&
                            ((!paramsFinishTicket?.solucaoRfo?.trim() &&
                              paramsFinishTicket?.causaRfo?.trim()) ||
                              requiredRfo) &&
                            "Solução do problema obrigatório"
                          }
                          sx={{
                            width: "100%",
                            "& .MuiFilledInput-root": { paddingTop: "20px" },
                            "& textarea": {
                              resize: "vertical",
                              minHeight: "100px",
                              maxHeight: "400px",
                            },
                          }}
                        />
                      </Box>
                    </Paper>

                    <Box sx={styles.boxButtonFinishAtendimento}>
                      <Button
                        disabled={loadingFinishTicket}
                        onClick={() => {
                          setConfirmacaoSaidaPaginaFinish(true);
                        }}
                      >
                        Cancelar
                      </Button>
                      <LoadingButton
                        loading={loadingFinishTicket}
                        onClick={finishTicket}
                        variant="contained"
                      >
                        Finalizar atendimento
                      </LoadingButton>
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          ) : isEditTicket ? (
            <>
              {loadingParams ? (
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Box
                  sx={{
                    height: "100vh",
                    overflow: "auto",
                    padding: "0 40px",
                  }}
                >
                  <Box sx={{ padding: "20px 0" }}>
                    <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                      Editar ticket - Protocolo {ticketDetails?.protocolo}
                    </Typography>
                  </Box>
                  <EditTicketComponent
                    erp={erp}
                    erpId={erpId}
                    loadingServicos={loadingServicos}
                    loadingCreateTicket={loadingCreateTicket}
                    loadingParams={loadingParams}
                    setServicos={setServicos}
                    servicos={servicos}
                    setDataTicket={setDataTicket}
                    dataTicket={dataTicket}
                    error={error}
                    statusAtendimento={statusAtendimento}
                    tipoAtendimento={tipoAtendimento}
                    origemContato={origemContato}
                    usuariosSelecionados={usuariosSelecionados}
                    setUsuariosSelecionados={setUsuariosSelecionados}
                    etapasFluxoAtendimento={etapasFluxoAtendimento}
                    userResponsaveis={userResponsaveis}
                    isEdit={true}
                  />
                  <Box sx={styles.containerButtonEdit}>
                    <Button
                      disabled={loadingCreateTicket}
                      onClick={() => {
                        setConfirmacaoSaidaPagina(true);
                      }}
                      size="small"
                    >
                      Cancelar
                    </Button>
                    <LoadingButton
                      onClick={() => editTicket()}
                      size="small"
                      loading={loadingCreateTicket}
                      variant="contained"
                    >
                      Salvar
                    </LoadingButton>
                  </Box>
                </Box>
              )}
            </>
          ) : (
            <>
              <Box sx={styles.containerHeaderModal}>
                {/* Linha 1: fechar + título. O botão era posicionado de forma
                    absoluta e o título compensava com margem — agora os dois
                    dividem a mesma linha de flex e nada precisa compensar. */}
                <Box sx={styles.headerTopRow}>
                  <Tooltip title="Fechar">
                    <IconButton
                      onClick={handleCloseAttempt}
                      size="small"
                      sx={styles.headerCloseButton}
                    >
                      <ArrowForwardIosOutlined sx={styles.clearIcon} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={tituloAtendimento}>
                    <Typography
                      id="modal-modal-title"
                      component="h2"
                      sx={styles.titleModal}
                    >
                      {tituloAtendimento}
                    </Typography>
                  </Tooltip>

                  {protocoloAtendimento && (
                    <CopyButton
                      value={protocoloAtendimento}
                      setSnackbar={setSnackbar}
                      title="Copiar protocolo"
                      mensagem="Protocolo copiado!"
                      sx={styles.headerCopyButton}
                    />
                  )}
                </Box>

                {/* Linha 2: chips e ações. Vira coluna no celular para que o
                    grupo de botões não seja espremido contra os chips. */}
                <Box sx={styles.headerBottomRow}>
                  <Box sx={styles.headerChips}>
                    {erp === "HUBSOFT" &&
                      ticketDetails?.status?.descricao &&
                      StatusChipModal(ticketDetails?.status?.descricao)}
                    {erp === "VOALLE" &&
                      status &&
                      StatusChipModal(convertStatusVoalle[status])}
                    {erp === "IXC" &&
                      ticketDetails?.status?.descricao &&
                      StatusChipModal(ticketDetails?.status?.descricao)}
                    {erp === "HUBSOFT" && ticketDetails?.tipo_atendimento && (
                      <Tooltip title={ticketDetails?.tipo_atendimento}>
                        <Chip
                          size="small"
                          sx={styles.chipTypeAtendimento}
                          label={
                            <Box sx={styles.containerStatusModal}>
                              <Typography sx={styles.titleChipModal}>
                                {ticketDetails?.tipo_atendimento}
                              </Typography>
                            </Box>
                          }
                        />
                      </Tooltip>
                    )}
                    {erp === "HUBSOFT" &&
                      ticketDetails?.fluxo_atendimento?.descricao &&
                      fluxoAtendimentoColor && (
                        <Tooltip
                          title={ticketDetails?.fluxo_atendimento?.descricao}
                        >
                          <Chip
                            size="small"
                            sx={{
                              ...styles.chipFluxo,
                              backgroundColor:
                                theme.palette.mode == "dark"
                                  ? theme.palette.colors[
                                      fluxoAtendimentoColor[
                                        ticketDetails?.fluxo_atendimento
                                          ?.descricao
                                      ]
                                    ].darker
                                  : theme.palette.colors[
                                      fluxoAtendimentoColor[
                                        ticketDetails?.fluxo_atendimento
                                          ?.descricao
                                      ]
                                    ].medium,
                            }}
                            label={
                              <Box sx={styles.containerStatusModal}>
                                <Typography sx={styles.titleChipModal}>
                                  {ticketDetails?.fluxo_atendimento?.descricao}
                                </Typography>
                              </Box>
                            }
                          />
                        </Tooltip>
                      )}
                    {erp === "IXC" && ticketDetails?.tipo_atendimento && (
                      <Tooltip title={ticketDetails?.tipo_atendimento}>
                        <Chip
                          size="small"
                          sx={styles.chipTypeAtendimento}
                          label={
                            <Box sx={styles.containerStatusModal}>
                              <Typography sx={styles.titleChipModal}>
                                {ticketDetails?.tipo_atendimento}
                              </Typography>
                            </Box>
                          }
                        />
                      </Tooltip>
                    )}
                    {erp === "VOALLE" && ticketDetails?.geral?.service && (
                      <Tooltip title={ticketDetails?.geral?.service}>
                        <Chip
                          size="small"
                          sx={styles.chipTypeAtendimento}
                          label={
                            <Box sx={styles.containerStatusModal}>
                              <Typography sx={styles.titleChipModal}>
                                {ticketDetails?.geral?.service}
                              </Typography>
                            </Box>
                          }
                        />
                      </Tooltip>
                    )}
                  </Box>

                  {erp === "HUBSOFT" &&
                    !isCliente &&
                    !somenteLeitura &&
                    ticketDetails?.status?.descricao !== "resolvido" &&
                    !ticketDetails?.configTicket && (
                      <ButtonGroup
                        size="small"
                        variant={
                          theme.palette.mode === "dark"
                            ? "outlined"
                            : "contained"
                        }
                        sx={styles.headerActions}
                      >
                        <Button
                          onClick={() => handleEditTicket()}
                          endIcon={<CreateOutlined />}
                        >
                          Editar
                        </Button>

                        <Button
                          onClick={() => getparamsFinishTicket()}
                          endIcon={<Check />}
                          color="warning"
                        >
                          Finalizar atendimento
                        </Button>
                      </ButtonGroup>
                    )}
                </Box>
              </Box>

              {/* Abas */}
              <Box sx={styles.containerTabs}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable tabs"
                  allowScrollButtonsMobile
                >
                  <Tab value={0} label={labelTabsErp.descricao} />
                  <Tab
                    value={1}
                    label={`${labelTabsErp.mensagens}${
                      ticketDetails?.atendimento_mensagem?.length > 0
                        ? ` (${ticketDetails?.atendimento_mensagem?.length})`
                        : ticketDetails?.reports?.length > 0
                          ? ` (${ticketDetails?.reports?.length})`
                          : ""
                    }`}
                  />
                  {erp === "HUBSOFT" && (
                    <Tab
                      value={2}
                      label={`Anexos${
                        ticketDetails?.anexos?.length > 0
                          ? ` (${ticketDetails?.anexos?.length})`
                          : ""
                      }`}
                    />
                  )}
                  {erp === "HUBSOFT" && (
                    <Tab
                      value={3}
                      label={`Ordem de serviço${
                        ticketDetails?.ordem_servico?.length > 0
                          ? ` (${ticketDetails?.ordem_servico?.length})`
                          : ""
                      }`}
                    />
                  )}
                  {erp === "HUBSOFT" && (!isCliente || ticketDetails?.rfo) && (
                    <Tab
                      value={4}
                      label={`RFO${ticketDetails?.rfo ? ` (1)` : ""}`}
                    />
                  )}
                  {isCliente && (
                    <Tab
                      value={5}
                      disabled={ticketDetails?.avaliacao?.length === 0}
                      label={"Avaliação"}
                    />
                  )}

                  {erp === "HUBSOFT" &&
                    (!isCliente ||
                      (isCliente &&
                        (ticketDetails?.historicoFluxoAtendimento?.length > 0 ||
                          ticketDetails?.allEtapasFluxoAtendimentos?.length >
                            0))) && (
                      <Tab
                        value={6}
                        label={`Linha do tempo${
                          ticketDetails?.historicoFluxoAtendimento?.length > 0
                            ? ` (${ticketDetails?.historicoFluxoAtendimento?.length})`
                            : ""
                        }`}
                      />
                    )}
                </Tabs>
              </Box>

              <Divider />

              {/* Conteúdo das Abas */}
              {value === 0 && (
                <DescricaoTicketComponent
                  ticketDetails={ticketDetails}
                  erp={erp}
                />
              )}

              {value === 1 && (erp === "HUBSOFT" || erp === "IXC") && (
                <MensagensTicketComponent
                  erp={erp}
                  erpId={erpId}
                  isEdit={isEdit}
                  ticketDetails={ticketDetails}
                  setTicketDetails={setTicketDetails}
                  itensPublic={itensPublic}
                  setItensPublic={setItensPublic}
                  canSendMessage={canSendMessage}
                  isCliente={isCliente}
                />
              )}

              {value === 1 && erp === "VOALLE" && (
                <ReportsComponent
                  reports={ticketDetails?.reports || []}
                  htmlForText={htmlForText}
                />
              )}

              {value === 2 && (
                <AnexosTicketComponent
                  erp={erp}
                  erpId={erpId}
                  ticketDetails={ticketDetails}
                  isEdit={isEdit}
                  setTicketDetails={setTicketDetails}
                  itensPublic={itensPublic}
                  setItensPublic={setItensPublic}
                  isCliente={isCliente}
                  canSendAnexo={canSendAnexo}
                />
              )}

              {value === 3 && (
                <OrdemServiceComponent
                  erpId={erpId}
                  ticketDetails={ticketDetails}
                  setTicketDetails={setTicketDetails}
                  isEdit={isEdit}
                  setOpenEditOS={setIsEditOs}
                  openEditOS={isEditOs}
                  setOpenNewOs={setIsNewOs}
                  openNewOs={isNewOs}
                />
              )}

              {value === 4 && (
                <RfoComponent
                  erpId={erpId}
                  isEdit={isEdit}
                  ticketDetails={ticketDetails}
                  setTicketDetails={setTicketDetails}
                  setSnackbar={setSnackbar}
                  setItensPublic={setItensPublic}
                  itensPublic={itensPublic}
                />
              )}
              {value === 5 && (
                <AnswerQuestionsComponent ticketDetails={ticketDetails} />
              )}
              {value === 6 && (
                <TimelineComponent ticketDetails={ticketDetails} erp={erp} />
              )}
            </>
          )}

          <InternoModalConfirmacaoSaida
            openConfirmacao={confirmacaoSaidaPagina}
            confirmLoad={false}
            setOpenConfirmacao={setConfirmacaoSaidaPagina}
            execute={handleCloseEditTicket}
            cancel={handleCancelNavigation}
            severity={"warning"}
            title={"Atenção"}
            contentText={
              "As alterações não salvas serão perdidas, deseja continuar?"
            }
            headerText={"Você está prestes a sair do modo de edição."}
            confirmText={"Continuar"}
          />
          <InternoModalConfirmacaoSaida
            openConfirmacao={confirmacaoFecharDrawer}
            confirmLoad={false}
            setOpenConfirmacao={setConfirmacaoFecharDrawer}
            execute={handleConfirmarFecharDrawer}
            cancel={() => setConfirmacaoFecharDrawer(false)}
            severity={"warning"}
            title={"Atenção"}
            contentText={
              "As alterações não salvas serão perdidas, deseja continuar?"
            }
            headerText={"Você está prestes a sair do modo de edição."}
            confirmText={"Continuar"}
          />
          <InternoModalConfirmacaoSaida
            openConfirmacao={confirmacaoSaidaPaginaFinish}
            confirmLoad={false}
            setOpenConfirmacao={setConfirmacaoSaidaPaginaFinish}
            execute={handleCloseFinishTicket}
            cancel={handleCancelNavigationFinish}
            severity={"warning"}
            title={"Atenção"}
            contentText={
              "As alterações não salvas serão perdidas, deseja continuar?"
            }
            headerText={"Você está prestes a sair do modo de edição."}
            confirmText={"Continuar"}
          />
        </Box>
      )}
    </Drawer>
  );
}
